module.exports = __webpack_public_path__ + "b1ed5ff673be7c71289b77b947183257.png";